module.exports = __webpack_public_path__ + "img/page02.86099e7b.gif";